import React from "react"
import { cn } from "~/lib/utils"

interface SnackbarProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode
}

/**
 * Snackbar container component - always visible when rendered
 */
export const Snackbar: React.FC<SnackbarProps> = ({
  children,
  className,
  ...props
}) => {
  return (
    <div className={cn("snackbar is-visible", className)} {...props}>
      {children}
    </div>
  )
}

interface SnackbarTextProps extends React.HTMLAttributes<HTMLSpanElement> {
  children: React.ReactNode
}

/**
 * Snackbar text component for displaying messages
 */
export const SnackbarText: React.FC<SnackbarTextProps> = ({
  children,
  className,
  ...props
}) => {
  return (
    <span className={cn("snackbar__text", className)} {...props}>
      {children}
    </span>
  )
}

interface SnackbarLinkProps
  extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string
  turboFrame?: string
  children: React.ReactNode
}

/**
 * Snackbar link component for action links
 */
export const SnackbarLink: React.FC<SnackbarLinkProps> = ({
  href,
  turboFrame = "_top",
  children,
  className,
  ...props
}) => {
  return (
    <a
      href={href}
      data-turbo-frame={turboFrame}
      className={cn("snackbar__link", className)}
      {...props}
    >
      {children}
    </a>
  )
}
